<template>
  <div class="columns is-multiline is-marginless mg-50px">
      <div class="column is-12">
        <qd-message
            v-if="messages.length > 0"
            :title="$t('general.info')"
            type="is-warning"
            aria-close-label="Close message">
            <template v-for="(message, index) in messages">
              <div :key="index + 'message'" v-html="message.message"></div>
              <br :key="index + 'br'" />
            </template>
        </qd-message>
      </div>

      <div class="column is-2" v-if="moduleSignatureElectroniqueActive && nbreSignatureEncours">
        <router-link :to="{ name: 'l.parametrage.signature_electronique',
            params: { type: constante.DEVIS } }"
            :class="{'text-access-no-permission': !checkPermissions(permSignature.lecture)}">
          <qd-message
            type="is-cumulFonce1"
            :closable= false
            class="clickable">
            <template #header>
              <div class="columns is-marginless is-vcentered">
                <div class="column is-11 is-paddingless">
                  {{ $t('detail.signatureElectronique.titleDevis') }}
                </div>
                <div class="column is-paddingless">
                  <b-icon icon="arrow-right-circle" ></b-icon>
                </div>
              </div>
            </template>
            <div class="has-text-centered">
              <h1 class="is-size-1 has-text-weight-bold" >
                {{ nbreSignatureEncours.nbreSignatureEncoursPourDevis }}
              </h1>
              <p>{{ $t('detail.signatureElectronique.nbreSignatureDevis') }}</p>
            </div>
          </qd-message>
        </router-link>
      </div>
      <div class="column is-2" v-if="moduleSignatureElectroniqueActive && nbreSignatureEncours">
        <router-link :to="{ name: 'l.parametrage.signature_electronique',
            params: { type: constante.COMMANDE } }"
            :class="{'text-access-no-permission': !checkPermissions(permSignature.lecture)}">
          <qd-message
            type="is-cumulFonce2"
            :closable= false
            class="clickable">
            <template #header>
              <div class="columns is-marginless is-vcentered">
                <div class="column is-11 is-paddingless">
                  {{ $t('detail.signatureElectronique.titleCommande') }}
                </div>
                <div class="column is-paddingless">
                  <b-icon icon="arrow-right-circle"></b-icon>
                </div>
              </div>
            </template>
            <div class="has-text-centered">
              <h1 class="is-size-1 has-text-weight-bold" >
                {{ nbreSignatureEncours.nbreSignatureEncoursPourCommande }}
              </h1>
              <p>{{ $t('detail.signatureElectronique.nbreSignatureCommande') }}</p>
            </div>
          </qd-message>
        </router-link>
      </div>
      <div class="column">
        <sprint-card
          v-if="currentSprint"
          :data="currentSprint"
          :title="$t('general.new')" />
      </div>
      <qd-loader is-full-page :active="isLoading"/>
  </div>
</template>

<script>

import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { getNbreSignatureEncours } from '@/api/signatureElectronique/signatureElectroniqueView';
import genererCritereRecherche from '@/services/signatureElectronique/genererCritereRechercheSignatureEncours';
import messageErreur from '@/services/general/messageErreur';
import { SIGNATURE_ELECTRONIQUE } from '@/configuration/general/permissionsParametrageConf';
import { DEVIS, COMMANDE } from '@/configuration/signatureElectronique/signatureElectroniqueConf';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import SprintCard from '@/components/parametrage/sprint/sprintCard';
import { getCurrentMessages } from '@/api/messageAcceuil';

const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const Sprint = createNamespacedHelpers('sprint');

export default {
  name: 'HomePage',
  data() {
    return {
      messages: [],
      nbreSignatureEncours: null,
      permSignature: SIGNATURE_ELECTRONIQUE,
      constante: {
        DEVIS,
        COMMANDE,
      },
      isLoading: false,
    };
  },
  components: {
    SprintCard,
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...Sprint.mapGetters({
      currentSprint: 'currentSprint',
    }),
    moduleSignatureElectroniqueActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.signatureElectronique.key);
    },
  },
  methods: {
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Sprint.mapActions({
      loadCurrentSprint: 'loadCurrentSprint',
    }),
    async loadMessages() {
      try {
        this.messages = (await getCurrentMessages()).data.result;
      } catch (e) {
        this.messages = [];
      }
    },
    async getNbreSignaturesElectroniquesEncours() {
      this.isLoading = true;
      try {
        const critere = genererCritereRecherche();
        await updateCritereWithParametreInterne(critere);
        this.nbreSignatureEncours = (await getNbreSignatureEncours({
          query: {
            ...critere,
            societeId: this.societeActiveId,
          },
          MaxResultCount: NO_PAGINATION,
          SkipCount: 0,
        })).data.result;
        this.isLoading = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isLoading = false;
        throw e;
      }
    },
  },
  async mounted() {
    await this.loadMessages();
    await this.loadCurrentSprint();
    this.setLockMenu(false);
    await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.signatureElectronique.key]);
    if (this.moduleSignatureElectroniqueActive) await this.getNbreSignaturesElectroniquesEncours();
    this.setInformationPage(this.$t('pageGeneral.home'));
  },
};
</script>

<style scoped>

</style>
